import { fetchPlaceByName } from 'actions/PlaceActions'
import TextButton from 'components/Luxkit/Button/TextButton'
import LineSearchIcon from 'components/Luxkit/Icons/line/LineSearchIcon'
import InlineGroup from 'components/Common/InlineGroup'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import Heading from 'components/Luxkit/Typography/Heading'
import { sortBy, take } from 'lib/arrayUtils'
import { encodeSearchParams } from 'lib/searchUtils'
import React, { useEffect, useMemo } from 'react'
import { connect } from 'react-redux'
import { useAppDispatch } from 'hooks/reduxHooks'
import config from 'constants/config'

interface Props {
  filteredLocations?: Array<string>;
  availableFilters?: App.OfferListAvailableFilters;
  locationToPlaces: Record<string, App.Place>;
}

const maxDestinations = 4

function FrontPageDiscoverMoreDestinationLinks(props: Props) {
  const { filteredLocations, locationToPlaces, availableFilters } = props
  const dispatch = useAppDispatch()

  useEffect(() => {
    filteredLocations.forEach(location => {
      dispatch(fetchPlaceByName(location))
    })
  // eslint-disable-next-line
  }, [filteredLocations])

  const destinationCombos = useMemo(() => {
    const items = filteredLocations.filter(location => !!locationToPlaces[location]).map(location => {
      const placeRecord = locationToPlaces[location]
      const count = availableFilters?.locations?.[location] ?? 0

      const searchItem: App.SearchItem = {
        searchType: 'destination',
        value: placeRecord.id,
        format: { mainText: placeRecord.canonicalName || location },
      }

      return {
        count,
        location,
        url: `/search?${encodeSearchParams({
          urlSearch: '',
          searchItem,
          rooms: [config.search.defaultOccupants],
          isFlexibleWithDate: true,
        })}`,
      }
    })

    return take(sortBy(items, item => item.count), maxDestinations)
  }, [filteredLocations, locationToPlaces, availableFilters])

  return (
    <VerticalSpacer gap={12}>
      <Heading variant="heading5" align="center">Discover more offers in</Heading>
      <InlineGroup wraps spacing="md" horizontal="center">
        {destinationCombos.map(combo =>
          <TextButton
            kind="primary"
            startIcon={<LineSearchIcon />}
            variant="ghost"
            key={combo.location}
            to={combo.url}
            size="large"
          >
            {combo.location}
          </TextButton>)}
      </InlineGroup>
    </VerticalSpacer>
  )
}

FrontPageDiscoverMoreDestinationLinks.defaultProps = {
  filteredLocations: [],
}

function mapStateToProps(state: App.State) {
  return {
    locationToPlaces: state.destination.locationToPlace,
  }
}

export default connect(mapStateToProps)(FrontPageDiscoverMoreDestinationLinks)
